import type { SVGProps } from "react"

const MTPBack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 1438" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 3908" clipPath="url(#prefix__a)">
      <path
        data-name="Path 39022"
        d="M276.147 89.373H73.853a13.394 13.394 0 00-13.379 13.379v129.51a13.394 13.394 0 0013.379 13.379h118.083a19.369 19.369 0 0119.08-23.012h78.51V102.752a13.394 13.394 0 00-13.379-13.379m-100.073 29.434h92.049a4.817 4.817 0 010 9.633h-92.049a4.817 4.817 0 110-9.633m0 12.844h24.618a4.817 4.817 0 110 9.633h-24.618a4.817 4.817 0 110-9.633m-92.053-25.688h66.361a4.817 4.817 0 010 9.633H84.021a4.817 4.817 0 010-9.633m0 12.844h66.361a4.817 4.817 0 110 9.633H84.021a4.817 4.817 0 010-9.633m0 12.844h66.361a4.817 4.817 0 110 9.633H84.021a4.817 4.817 0 110-9.633m0 12.844h129.511a4.817 4.817 0 010 9.633H84.021a4.817 4.817 0 110-9.633m0 27.829h35.321a4.816 4.816 0 110 9.632H84.021a4.816 4.816 0 110-9.632m0 12.843h9.633a4.817 4.817 0 110 9.633h-9.633a4.817 4.817 0 010-9.633m0 12.844h17.126a4.817 4.817 0 010 9.633H84.021a4.817 4.817 0 010-9.633m56.728 22.477H84.021a4.817 4.817 0 110-9.633h56.728a4.817 4.817 0 110 9.633m13.914-12.844h-17.125a4.817 4.817 0 010-9.633h17.126a4.817 4.817 0 110 9.633m-21.942-17.661a4.822 4.822 0 014.817-4.817h9.635a4.817 4.817 0 110 9.633h-9.633a4.822 4.822 0 01-4.817-4.817m27.294-8.028h-22.48a4.816 4.816 0 110-9.632h22.477a4.816 4.816 0 110 9.632m16.059-14.981a4.817 4.817 0 110-9.633h66.361a4.817 4.817 0 110 9.633zM273.742 202a2.946 2.946 0 01-2.943 2.943h-1.9a4.932 4.932 0 01-9.738 0h-12.048a4.932 4.932 0 01-9.738 0h-1.9a2.946 2.946 0 01-2.943-2.943v-6.114a2.946 2.946 0 012.943-2.943h2.521a1.339 1.339 0 001.178-.7l2.253-4.184a2.941 2.941 0 012.591-1.55h13.13a2.956 2.956 0 012.163.947l4.669 5.058a1.345 1.345 0 00.984.431h5.832a2.946 2.946 0 012.943 2.942z"
        fill="#fff"
      />
      <path
        data-name="Path 39023"
        d="M242.244 199.19a4.947 4.947 0 014.869 4.148h12.042a4.932 4.932 0 019.739 0h1.9a1.34 1.34 0 001.338-1.338v-6.115a1.34 1.34 0 00-1.338-1.337h-5.832a2.953 2.953 0 01-2.163-.948l-4.669-5.057a1.345 1.345 0 00-.984-.431h-13.13a1.336 1.336 0 00-1.178.705l-2.253 4.184a2.939 2.939 0 01-2.591 1.548h-2.521a1.339 1.339 0 00-1.338 1.338v6.114a1.339 1.339 0 001.338 1.338h1.9a4.947 4.947 0 014.869-4.148"
        fill="#fff"
      />
      <path
        data-name="Path 39024"
        d="M191.936 245.642H73.854a13.393 13.393 0 01-13.379-13.379V102.752a13.394 13.394 0 0113.379-13.384h202.293a13.4 13.4 0 0113.379 13.379v119.882h1.605V102.752a15 15 0 00-14.984-14.984H73.854a15 15 0 00-14.985 14.984v129.51a15 15 0 0014.985 14.985h118.462a19.127 19.127 0 01-.38-1.6"
        fill="#98a300"
      />
      <path
        data-name="Path 39025"
        d="M84.021 113.991h66.361a3.211 3.211 0 000-6.422H84.021a3.211 3.211 0 000 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39026"
        d="M84.022 115.596h66.361a4.817 4.817 0 000-9.633H84.022a4.817 4.817 0 000 9.633m0-8.028h66.361a3.211 3.211 0 010 6.422H84.022a3.211 3.211 0 010-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39027"
        d="M84.021 180.351h35.321a3.211 3.211 0 100-6.422H84.021a3.211 3.211 0 000 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39028"
        d="M84.022 181.957h35.321a4.817 4.817 0 100-9.633H84.022a4.817 4.817 0 100 9.633m0-8.028h35.321a3.211 3.211 0 110 6.422H84.022a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39029"
        d="M160.015 173.93h-22.477a3.211 3.211 0 100 6.422h22.477a3.211 3.211 0 000-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39030"
        d="M160.016 172.324h-22.477a4.817 4.817 0 100 9.633h22.477a4.817 4.817 0 000-9.633m0 8.028h-22.477a3.211 3.211 0 010-6.422h22.477a3.211 3.211 0 010 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39031"
        d="M84.021 139.679h66.361a3.211 3.211 0 000-6.422H84.021a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39032"
        d="M84.022 141.284h66.361a4.817 4.817 0 100-9.633H84.022a4.817 4.817 0 100 9.633m0-8.028h66.361a3.211 3.211 0 010 6.422H84.022a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39033"
        d="M176.07 139.679h24.618a3.211 3.211 0 100-6.422H176.07a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39034"
        d="M176.07 141.284h24.618a4.817 4.817 0 100-9.633H176.07a4.817 4.817 0 000 9.633m0-8.028h24.618a3.211 3.211 0 110 6.422H176.07a3.211 3.211 0 010-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39035"
        d="M176.07 165.367h66.361a3.211 3.211 0 100-6.422H176.07a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39036"
        d="M247.248 162.156a4.822 4.822 0 00-4.817-4.817H176.07a4.817 4.817 0 000 9.633h66.361a4.822 4.822 0 004.816-4.817m-71.177-3.211h66.361a3.211 3.211 0 010 6.422H176.07a3.211 3.211 0 010-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39037"
        d="M84.021 206.039h17.125a3.211 3.211 0 100-6.422H84.021a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39038"
        d="M84.022 207.644h17.125a4.817 4.817 0 100-9.633H84.022a4.817 4.817 0 100 9.633m0-8.028h17.125a3.211 3.211 0 110 6.422H84.022a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39039"
        d="M154.663 199.618h-17.125a3.211 3.211 0 100 6.422h17.125a3.211 3.211 0 000-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39040"
        d="M154.664 198.012h-17.125a4.817 4.817 0 100 9.633h17.125a4.817 4.817 0 100-9.633m0 8.028h-17.125a3.211 3.211 0 110-6.422h17.125a3.211 3.211 0 010 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39041"
        d="M140.749 212.462H84.021a3.211 3.211 0 100 6.422h56.728a3.211 3.211 0 100-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39042"
        d="M140.749 210.856H84.022a4.817 4.817 0 100 9.633h56.728a4.817 4.817 0 100-9.633m0 8.028H84.022a3.211 3.211 0 110-6.422h56.728a3.211 3.211 0 110 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39043"
        d="M84.021 126.835h66.361a3.211 3.211 0 000-6.422H84.021a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39044"
        d="M84.022 128.44h66.361a4.817 4.817 0 000-9.633H84.022a4.817 4.817 0 000 9.633m0-8.028h66.361a3.211 3.211 0 010 6.422H84.022a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39045"
        d="M84.021 152.523h129.511a3.211 3.211 0 000-6.422H84.021a3.211 3.211 0 000 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39046"
        d="M84.022 154.128h129.51a4.817 4.817 0 100-9.633H84.022a4.817 4.817 0 100 9.633m0-8.028h129.51a3.211 3.211 0 010 6.422H84.022a3.211 3.211 0 010-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39047"
        d="M176.07 126.835h92.049a3.211 3.211 0 000-6.422H176.07a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39048"
        d="M176.07 128.44h92.049a4.817 4.817 0 000-9.633H176.07a4.817 4.817 0 000 9.633m0-8.028h92.049a3.211 3.211 0 010 6.422H176.07a3.211 3.211 0 010-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39049"
        d="M84.021 193.195h9.633a3.211 3.211 0 100-6.422h-9.633a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39050"
        d="M84.022 194.8h9.633a4.817 4.817 0 100-9.633h-9.633a4.817 4.817 0 100 9.633m0-8.028h9.633a3.211 3.211 0 110 6.422h-9.633a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39051"
        d="M137.538 193.195h9.633a3.211 3.211 0 100-6.422h-9.633a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39052"
        d="M137.539 194.8h9.633a4.817 4.817 0 100-9.633h-9.633a4.817 4.817 0 100 9.633m0-8.028h9.633a3.211 3.211 0 110 6.422h-9.633a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39053"
        d="M318.96 242.056a17.3 17.3 0 00-17.285-17.285h-90.66a17.273 17.273 0 00-16.906 20.872c.058.272.137.535.208.8s.131.539.213.8a17.313 17.313 0 0016.485 12.092h90.66a17.3 17.3 0 0017.285-17.284m-47.475-1.375a3.058 3.058 0 012.723-1.626 2.823 2.823 0 011.361.313 2.708 2.708 0 01.94.76v-.964h1.385v6.638h-1.385v-.988a2.723 2.723 0 01-.953.783c-.039.02-.085.027-.125.046a2.9 2.9 0 01-2.434 0 3.05 3.05 0 01-.38-.166 3.215 3.215 0 01-1.132-1.23 3.849 3.849 0 01-.41-1.795 3.71 3.71 0 01.41-1.771m-4.577-1.518h1.374v.964a2.107 2.107 0 01.8-.783 2.362 2.362 0 011.192-.289v1.421h-.349a1.7 1.7 0 00-1.23.41 1.979 1.979 0 00-.409 1.421v3.494h-1.374v-6.638zm-5.049 0h.783v-1.65h1.389v1.65h1.615v1.121h-1.615v3.674a.744.744 0 00.169.543.921.921 0 00.6.156h.843v1.144h-1.084a2.581 2.581 0 01-.913-.158 1.618 1.618 0 01-.509-.275 1.789 1.789 0 01-.493-1.41v-3.674h-.783zm-2.629 4.241a6.5 6.5 0 00-1.121-.4 11.013 11.013 0 01-1.217-.4 2.189 2.189 0 01-.819-.59 1.567 1.567 0 01-.337-1.049 1.607 1.607 0 01.313-.963 2.073 2.073 0 01.892-.7 3.392 3.392 0 011.35-.253 2.734 2.734 0 011.82.578 2.03 2.03 0 01.747 1.554h-1.374a.977.977 0 00-.361-.711 1.354 1.354 0 00-.88-.265 1.424 1.424 0 00-.832.206.633.633 0 00-.289.542.589.589 0 00.193.446 1.476 1.476 0 00.47.289q.278.1.82.253a7.947 7.947 0 011.181.4 2.133 2.133 0 01.807.578 1.55 1.55 0 01.35 1.024 1.714 1.714 0 01-.314 1.011 2.07 2.07 0 01-.867.685.282.282 0 00-.025.014 3.251 3.251 0 01-1.338.254 3.487 3.487 0 01-1.381-.268c-.009 0-.019-.005-.029-.01a2.541 2.541 0 01-.975-.772 1.943 1.943 0 01-.386-1.1h1.422a.991.991 0 00.4.711 1.513 1.513 0 00.928.277 1.548 1.548 0 00.892-.217.684.684 0 00.325-.578.589.589 0 00-.362-.554m-9.547 2.239v-6.48h1.373v6.638h-1.373zm-.735-7.962l2.663-1.47v1.169l-2.663 1.313zm-7.089 1.482h1.369v.759a2.273 2.273 0 01.855-.638 2.788 2.788 0 011.121-.229 2.938 2.938 0 011.4.325 2.294 2.294 0 01.975.963 3.167 3.167 0 01.35 1.542v3.915h-1.361v-3.711a1.9 1.9 0 00-.446-1.361 1.575 1.575 0 00-1.217-.482 1.615 1.615 0 00-1.229.482 1.909 1.909 0 00-.445 1.361v3.711h-1.373v-6.638zm-8.215 1.518a3.062 3.062 0 012.736-1.626 3.019 3.019 0 011.277.289 2.548 2.548 0 011.011.747v-3.206h1.386v8.916h-1.386v-1a2.553 2.553 0 01-.94.8c-.039.02-.083.027-.123.046a2.887 2.887 0 01-1.238.268 3.035 3.035 0 01-1.2-.268 3 3 0 01-.386-.166 3.226 3.226 0 01-1.133-1.23 3.862 3.862 0 01-.409-1.795 3.722 3.722 0 01.409-1.771m-8.166 0a3.071 3.071 0 011.132-1.192 3.038 3.038 0 011.59-.433 2.817 2.817 0 011.361.313 2.689 2.689 0 01.94.76v-.964h1.386v6.638h-1.386v-.988a2.718 2.718 0 01-.952.783c-.039.02-.085.027-.125.046a2.9 2.9 0 01-2.435 0 3.048 3.048 0 01-.38-.166 3.231 3.231 0 01-1.132-1.23 3.862 3.862 0 01-.409-1.795 3.722 3.722 0 01.409-1.771m-6.971 4.049l3.88-6.109h-3.88v-1.192h5.518v1.072l-3.892 6.108h3.892v1.192h-5.519v-1.071zm67.263 1.071h-1.361v-3.711a1.909 1.909 0 00-.445-1.361 1.578 1.578 0 00-1.217-.482 1.614 1.614 0 00-1.229.482 1.9 1.9 0 00-.446 1.361v3.711h-1.373v-6.638h1.373v.759a2.282 2.282 0 01.855-.638 2.788 2.788 0 011.121-.229 2.938 2.938 0 011.4.325 2.3 2.3 0 01.976.963 3.048 3.048 0 01.316 1.227c.009.107.033.2.033.316v3.915zm8.114 0h-1.386v-.988a2.728 2.728 0 01-.952.783 3.1 3.1 0 01-2.94-.12 3.223 3.223 0 01-1.132-1.23 3.854 3.854 0 01-.406-1.757v-.037a3.751 3.751 0 01.345-1.595c.026-.057.036-.122.065-.177a3.2 3.2 0 01.6-.771 2.73 2.73 0 011.361-.757 3.156 3.156 0 01.759-.1 2.817 2.817 0 011.361.313 2.7 2.7 0 01.94.76v-.964h1.386z"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39054"
        d="M291.475 240.512a1.983 1.983 0 00-2.723.759 2.383 2.383 0 00-.277 1.181 2.526 2.526 0 00.277 1.205 2.111 2.111 0 00.747.8 1.985 1.985 0 00.988.264 1.93 1.93 0 001.723-1.036 2.43 2.43 0 00.289-1.2 2.366 2.366 0 00-.289-1.193 1.95 1.95 0 00-.735-.771"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39055"
        d="M273.506 244.452a1.979 1.979 0 00.988.264 1.93 1.93 0 001.723-1.036 2.43 2.43 0 00.289-1.2 2.366 2.366 0 00-.289-1.193 1.971 1.971 0 00-3.458-.012 2.372 2.372 0 00-.277 1.181 2.514 2.514 0 00.277 1.205 2.112 2.112 0 00.747.8"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39056"
        d="M235.67 244.452a1.979 1.979 0 00.988.264 1.926 1.926 0 001.722-1.036 2.43 2.43 0 00.289-1.2 2.366 2.366 0 00-.289-1.193 1.97 1.97 0 00-3.457-.012 2.372 2.372 0 00-.277 1.181 2.513 2.513 0 00.277 1.205 2.1 2.1 0 00.747.8"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39057"
        d="M227.503 244.452a1.985 1.985 0 00.988.264 1.926 1.926 0 001.723-1.036 2.43 2.43 0 00.289-1.2 2.366 2.366 0 00-.289-1.193 1.97 1.97 0 00-3.457-.012 2.372 2.372 0 00-.277 1.181 2.513 2.513 0 00.277 1.205 2.109 2.109 0 00.746.8"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39058"
        d="M301.674 222.63h-90.658a19.369 19.369 0 00-19.08 23.012 20.026 20.026 0 00.38 1.6 19.444 19.444 0 0018.7 14.233h90.659a19.426 19.426 0 100-38.851m-90.659 36.71a17.313 17.313 0 01-16.485-12.093c-.083-.262-.143-.534-.214-.8s-.149-.532-.207-.8a17.273 17.273 0 0116.906-20.872h90.659a17.285 17.285 0 110 34.57z"
        fill="#98a300"
      />
      <path
        data-name="Path 39059"
        d="M292.499 240.126a2.7 2.7 0 00-.94-.76 2.817 2.817 0 00-1.361-.313 3.156 3.156 0 00-.759.1 2.73 2.73 0 00-1.361.757 3.2 3.2 0 00-.6.771c-.029.055-.04.12-.065.177a3.751 3.751 0 00-.345 1.595v.037a3.854 3.854 0 00.406 1.757 3.223 3.223 0 001.132 1.23 3.1 3.1 0 002.94.12 2.728 2.728 0 00.952-.783v.988h1.386v-6.638h-1.386zm-.289 3.554a1.93 1.93 0 01-1.723 1.036 1.985 1.985 0 01-.988-.264 2.111 2.111 0 01-.747-.8 2.526 2.526 0 01-.277-1.205 2.383 2.383 0 01.277-1.181 1.96 1.96 0 013.458.012 2.366 2.366 0 01.289 1.193 2.43 2.43 0 01-.289 1.2"
        fill="#98a300"
      />
      <path
        data-name="Path 39060"
        d="M262.643 243.958a1.789 1.789 0 00.493 1.41 1.606 1.606 0 00.509.275 2.576 2.576 0 00.913.158h1.084v-1.144h-.843a.921.921 0 01-.6-.156.744.744 0 01-.169-.543v-3.674h1.615v-1.121h-1.617v-1.655h-1.385v1.65h-.783v1.121h.783z"
        fill="#98a300"
      />
      <path
        data-name="Path 39061"
        d="M258.376 244.752a1.513 1.513 0 01-.928-.277.991.991 0 01-.4-.711h-1.42a1.943 1.943 0 00.386 1.1 2.541 2.541 0 00.975.772c.01 0 .02.005.029.01a3.487 3.487 0 001.381.268 3.251 3.251 0 001.338-.254.282.282 0 01.025-.014 2.07 2.07 0 00.867-.685 1.714 1.714 0 00.314-1.011 1.55 1.55 0 00-.35-1.024 2.133 2.133 0 00-.807-.578 7.947 7.947 0 00-1.181-.4q-.543-.156-.82-.253a1.476 1.476 0 01-.47-.289.589.589 0 01-.193-.446.633.633 0 01.289-.542 1.424 1.424 0 01.832-.206 1.354 1.354 0 01.88.265.977.977 0 01.361.711h1.374a2.03 2.03 0 00-.747-1.554 2.734 2.734 0 00-1.82-.578 3.392 3.392 0 00-1.35.253 2.073 2.073 0 00-.892.7 1.607 1.607 0 00-.313.963 1.567 1.567 0 00.337 1.049 2.189 2.189 0 00.819.59 11.013 11.013 0 001.217.4 6.5 6.5 0 011.121.4.589.589 0 01.362.554.684.684 0 01-.325.578 1.548 1.548 0 01-.892.217"
        fill="#98a300"
      />
      <path
        data-name="Path 39062"
        d="M226.611 245.476a2.889 2.889 0 00.38.165 2.892 2.892 0 002.435 0c.041-.018.087-.025.125-.045a2.718 2.718 0 00.952-.783v.988h1.387v-6.638h-1.386v.964a2.688 2.688 0 00-.94-.76 2.817 2.817 0 00-1.361-.313 3.038 3.038 0 00-1.59.433 3.071 3.071 0 00-1.132 1.192 3.722 3.722 0 00-.409 1.771 3.862 3.862 0 00.409 1.795 3.231 3.231 0 001.132 1.23m.146-4.205a1.959 1.959 0 013.457.012 2.366 2.366 0 01.289 1.193 2.43 2.43 0 01-.289 1.2 1.926 1.926 0 01-1.723 1.036 1.985 1.985 0 01-.988-.264 2.109 2.109 0 01-.746-.8 2.514 2.514 0 01-.277-1.205 2.372 2.372 0 01.277-1.181"
        fill="#98a300"
      />
      <path
        data-name="Path 39063"
        d="M234.778 245.477a2.849 2.849 0 00.386.165 3.017 3.017 0 001.2.269 2.872 2.872 0 001.238-.269c.04-.018.085-.025.123-.045a2.553 2.553 0 00.94-.8v1h1.386v-8.916h-1.386v3.206a2.548 2.548 0 00-1.011-.747 3.019 3.019 0 00-1.277-.289 3.062 3.062 0 00-2.736 1.626 3.722 3.722 0 00-.409 1.771 3.862 3.862 0 00.409 1.795 3.226 3.226 0 001.133 1.23m.144-4.205a1.959 1.959 0 013.457.012 2.366 2.366 0 01.289 1.193 2.43 2.43 0 01-.289 1.2 1.926 1.926 0 01-1.722 1.036 1.979 1.979 0 01-.988-.264 2.1 2.1 0 01-.747-.8 2.513 2.513 0 01-.277-1.205 2.372 2.372 0 01.277-1.181"
        fill="#98a300"
      />
      <path data-name="Path 39064" d="M251.611 236.21l-2.663 1.47v1.013l2.663-1.313z" fill="#98a300" />
      <path
        data-name="Path 39065"
        d="M272.614 245.476a2.89 2.89 0 00.38.165 2.889 2.889 0 002.434 0c.041-.018.087-.025.125-.045a2.723 2.723 0 00.953-.783v.988h1.385v-6.638h-1.377v.964a2.708 2.708 0 00-.94-.76 2.823 2.823 0 00-1.361-.313 3.058 3.058 0 00-2.723 1.626 3.71 3.71 0 00-.41 1.771 3.849 3.849 0 00.41 1.795 3.215 3.215 0 001.132 1.23m.144-4.205a1.96 1.96 0 013.458.012 2.366 2.366 0 01.289 1.193 2.43 2.43 0 01-.289 1.2 1.93 1.93 0 01-1.723 1.036 1.979 1.979 0 01-.988-.264 2.112 2.112 0 01-.747-.8 2.514 2.514 0 01-.277-1.205 2.372 2.372 0 01.277-1.181"
        fill="#98a300"
      />
      <path
        data-name="Path 39066"
        d="M224.027 245.802v-1.192h-3.892l3.892-6.108v-1.072h-5.519v1.192h3.88l-3.88 6.109v1.071z"
        fill="#98a300"
      />
      <path
        data-name="Path 39067"
        d="M243.233 245.8v-3.711a1.909 1.909 0 01.445-1.361 1.615 1.615 0 011.229-.482 1.575 1.575 0 011.217.482 1.9 1.9 0 01.446 1.361v3.711h1.361v-3.915a3.167 3.167 0 00-.35-1.542 2.294 2.294 0 00-.975-.963 2.938 2.938 0 00-1.4-.325 2.788 2.788 0 00-1.121.229 2.273 2.273 0 00-.855.638v-.759h-1.373v6.638z"
        fill="#98a300"
      />
      <path data-name="Path 39068" d="M251.057 245.641v-6.48h-1.373v6.638h1.373z" fill="#98a300" />
      <path
        data-name="Path 39069"
        d="M268.283 245.8v-3.491a1.979 1.979 0 01.409-1.421 1.7 1.7 0 011.23-.41h.349v-1.421a2.362 2.362 0 00-1.192.289 2.107 2.107 0 00-.8.783v-.964h-1.374v6.638z"
        fill="#98a300"
      />
      <path
        data-name="Path 39070"
        d="M285.771 241.885c0-.113-.025-.209-.033-.316a3.048 3.048 0 00-.316-1.227 2.3 2.3 0 00-.976-.963 2.938 2.938 0 00-1.4-.325 2.788 2.788 0 00-1.121.229 2.282 2.282 0 00-.855.638v-.759h-1.373v6.638h1.373v-3.711a1.9 1.9 0 01.446-1.361 1.614 1.614 0 011.229-.482 1.578 1.578 0 011.217.482 1.909 1.909 0 01.445 1.361v3.711h1.361v-3.915z"
        fill="#98a300"
      />
      <path
        data-name="Path 39071"
        d="M270.796 192.942h-5.832a1.345 1.345 0 01-.984-.431l-4.669-5.055a2.956 2.956 0 00-2.163-.947h-13.13a2.941 2.941 0 00-2.591 1.55l-2.253 4.184a1.339 1.339 0 01-1.178.7h-2.521a2.946 2.946 0 00-2.943 2.943V202a2.946 2.946 0 002.943 2.943h1.9a4 4 0 010-1.605h-1.9a1.34 1.34 0 01-1.338-1.338v-6.114a1.34 1.34 0 011.338-1.338h2.521a2.939 2.939 0 002.591-1.548l2.253-4.184a1.337 1.337 0 011.178-.705h13.13a1.342 1.342 0 01.984.431l4.669 5.057a2.953 2.953 0 002.163.948h5.832a1.34 1.34 0 011.338 1.337v6.115a1.34 1.34 0 01-1.338 1.338h-1.9a4 4 0 010 1.605h1.9a2.946 2.946 0 002.943-2.943v-6.115a2.946 2.946 0 00-2.943-2.942"
        fill="#98a300"
      />
      <path data-name="Path 39072" d="M259.156 203.337h-12.042a4 4 0 010 1.605h12.042a4 4 0 010-1.605" fill="#98a300" />
      <path
        data-name="Path 39073"
        d="M242.244 200.795a3.393 3.393 0 103.237 2.542 3.345 3.345 0 00-3.237-2.542"
        fill="#fff"
      />
      <path
        data-name="Path 39074"
        d="M247.113 203.338a4.932 4.932 0 00-9.738 0 4 4 0 000 1.605 4.932 4.932 0 009.738 0 4 4 0 000-1.605m-1.524.8a3.393 3.393 0 11-.108-.8 3.316 3.316 0 01.108.8"
        fill="#98a300"
      />
      <path
        data-name="Path 39075"
        d="M264.025 200.795a3.393 3.393 0 103.237 2.542 3.345 3.345 0 00-3.237-2.542"
        fill="#fff"
      />
      <path
        data-name="Path 39076"
        d="M268.894 203.338a4.932 4.932 0 00-9.738 0 4 4 0 000 1.605 4.932 4.932 0 009.738 0 4 4 0 000-1.605m-1.524.8a3.393 3.393 0 11-.108-.8 3.316 3.316 0 01.108.8"
        fill="#98a300"
      />
    </g>
  </svg>
)
export { MTPBack }
